import { Component, Input, OnInit } from '@angular/core';
import { AnchorItem } from '@product/shared/models/AnchorItem';

@Component({
  selector: 'app-anchor',
  templateUrl: './anchor.component.html',
  styleUrls: ['./anchor.component.less'],
})
export class AnchorComponent implements OnInit {
  offset = window.innerHeight / 3;
  @Input() anchorItems: AnchorItem[] = [];
  constructor() {}

  ngOnInit(): void {}
}
